
export { logger, LogLevel } from './LoggingService';
export type { LogContext } from './LoggingService';

// Import logger to use in convenience exports
import { logger } from './LoggingService';

// Convenience exports for common logging patterns
export const logError = (message: string, context?: any, error?: Error) => 
  logger.error(message, { data: context }, error);

export const logWarn = (message: string, context?: any) => 
  logger.warn(message, { data: context });

export const logInfo = (message: string, context?: any) => 
  logger.info(message, { data: context });

export const logDebug = (message: string, context?: any) => 
  logger.debug(message, { data: context });

// Service-specific loggers for easy access
export const studentLogger = logger.studentService;
export const teacherLogger = logger.teacherService;
export const storageLogger = logger.storageService;
